import { useQuery } from '@tanstack/react-query';

import { getTags } from '@arrived/api_v2';
import { Tag } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { tagsQueryKey } from './tags.keys';

export function useGetTagsQuery(options?: UseQueryOptions<Tag[]>): UseQueryResult<Tag[]> {
  return useQuery(tagsQueryKey, async () => getTags(), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: options?.enabled ?? true,
  });
}
